import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RoomC from "../components/RoomC";
import BlogC from "../components/BlogC";
import FacilitiesC from "../components/FacilitiesC";
import axios from "axios";
import TestimonialC from "../components/TestimonialC";
import RoomType from "../components/RoomType";

const Home = () => {

  const [rooms,setRooms] = useState([]);

  useEffect (() =>{
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const UrlRooms = process.env.REACT_APP_API_ROOMS;
    const saved = localStorage.getItem("rooms");
    if (saved) setRooms(JSON.parse(saved));
    else {
      axios.get(`${apiBaseUrl}${UrlRooms}`)
          .then((response) => {
            setRooms(response.data);
            localStorage.setItem("rooms", JSON.stringify(response.data));
          })
          .catch(error => console.error("Fetch Error", error));
    }
  },[]);
  console.log("C rooms:", rooms);

    return (
        <main className="site-main">
        <section className="home-banner-area" id="home">
          <div className="container h-100">
            <div className="home-banner">
              <div className="text-center">
                <h4>Luxury <em>is</em> personal</h4>
                <h1>Welcome to Elite Riyadh Hotel</h1>
                <a className="button home-banner-btn" href="#">Book Now</a>
              </div>
            </div>
          </div>
        </section>

        <form className="form-search form-search-position">
          <div className="container">
            <div className="row">
              <div className="col-sm">
                    <div className="form-group">
                      <div className="form-select-custom">
                        <label htmlFor="checkIn">Check In</label>
                        <input id="checkIn" className="form-control" type="date" placeholder="Enter your keywords.." required />
                      </div>
                    </div>
                  </div>
              <div className="col-sm gutters-19">
                    <div className="form-group">
                      <div className="form-select-custom">
                        <label htmlFor="checkOut">Check Out</label>
                        <input id="checkOut" className="form-control" type="date" placeholder="Enter your keywords.."
                               required/>
                      </div>
                    </div>
                  </div>
            </div>
            <div className="row">
              <div className="col-sm gutters-19">
                <div className="form-group">
                  <div className="form-select-custom">
                    <RoomType />
                  </div>
                </div>
              </div>
              <div className="col-sm gutters-19">
                <div className="form-group">
                  <div className="form-select-custom">
                    <select name="" id="">
                      <option value="" disabled selected>Guest</option>
                      <option value="Guest 1">Guest 1</option>
                      <option value="Guest 2">Guest 2</option>
                      <option value="Guest 3">Guest 3</option>
                      <option value="Guest 4">Guest 4</option>
                      <option value="Guest 5">Guest 5</option>
                      <option value="Guest 5+">Guest 5+</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 gutters-19">
                <div className="form-group">
                  <button className="button button-form" type="submit" ><Link className="nav-link" to={"/room"}>Check Availability</Link></button>
                </div>
              </div>
            </div>
          </div>
        </form>

        <section className="welcome">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 mb-4 mb-lg-0">
                <div className="row no-gutters welcome-images">
                  <div className="col-sm-7">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner1.png" alt="Card image cap" />
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner2.png" alt="Card image cap" />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner3.png" alt="Card image cap" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="welcome-content">
                  <h2 className="mb-4"><span className="d-block">Welcome</span> to our residence</h2>
                  <p>Beginning blessed second a creepeth. Darkness wherein fish years good air whose after seed appear midst evenin, appear void give third bearing divide one so blessed moved firmament gathered </p>
                  <p>Beginning blessed second a creepeth. Darkness wherein fish years good air whose after seed appear midst evenin, appear void give third bearing divide one so blessed</p>
                  <a className="button button--active home-banner-btn mt-4" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section-margin">
          <div className="container">
            <div className="section-intro text-center pb-80px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>Explore Our Rooms</h2>
            </div>

            {/* Rooms  */}
            <RoomC />

          </div>
        </section>

        <section className="video-area">
          <div className="container">
            <div className="row justify-content-center align-items-center flex-column text-center">
              <h3>Seaplace</h3>
              <p>View four has said does men saw find dear shy talent</p>
            </div>
          </div>  
        </section>

        <section className="section-padding bg-porcelain">
          <div className="container">
            <div className="section-intro text-center pb-80px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>Special Facilities</h2>
            </div>
            <div className="special-img mb-30px">
              <img className="img-fluid" src="img/home/special.png" alt="" />
            </div>
    
            <FacilitiesC />
           
          </div>
        </section>

        <section className="section-margin">
          <div className="container">
            <div className="section-intro text-center pb-20px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>Our Guest Love Us</h2>
            </div>
            
            <TestimonialC />
        

          </div>
        </section>
       
        <section className="section-margin">
          <div className="container">
            <div className="section-intro text-center pb-80px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>News & Events</h2>
            </div>
    
            <BlogC />
          </div>
        </section>
        
      </main>
    );
};

export default Home;